import { Component } from 'react';

class ErrorBoundary extends Component {
  state = {
    hasError: false
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ hasError: false });
  }

  componentDidCatch(error, info) {
    this.setState({hasError: true })
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/book/blocks/ErrorBoundary.js